import { useLocation } from 'react-router-dom'
import { Box, Stack, Link } from '@mui/material'
import { BaseDivider } from 'layout'
import { BaseTesto, BaseTitolo } from 'text'
import { useRoutes } from '../navigation/RoutesProvider'
import { useContextGenerico } from '../util/ContextGenericoProvider'

export default function Footer() {
  const { titoloApp, dataBuild, versione, versioneLibreria, versioniLibrerieExtra } = useContextGenerico()

  const { routeHome } = useRoutes()
  const { pathname } = useLocation()
  // Mostro il footer solo nella pagina home
  // Nelle altre pagine inserisco solo un piccolo padding 
  if (pathname !== routeHome.pathAssoluto) return <Box sx={{ pb: 1 }} />

  return (
    <Box sx={{ pb: 1, textAlign: 'center' }} className='footer'>
      <BaseDivider sx={{ borderColor: 'grey.400' }} />
        <Stack direction='column' spacing={0} sx={{ justifyContent: 'center' }}>
          <Stack direction='row' spacing={0} sx={{ justifyContent: 'center' }}>
            <BaseTitolo noMargine sx={{marginTop: '7px'}}>{titoloApp}</BaseTitolo>
            <Box
              component='a'
              href='http://www.dedanext.it/'
              target='_blank'
              rel='noreferrer'             
            >
              <Box
                sx={{height:'46px'}}
                component='img'
                height='46px'
                alt='http://www.dedanext.it/'
                src='https://contnet.eu/img/loghi/last/logo_deda_next.svg'  />
            </Box>
          </Stack>
           <BaseTesto>
            <Box component='span' sx={{ fontSize: '0.8em', ml: 3, lineHeight: '1.125' }}>
              Versione rilasciata il: {dataBuild} | Versione applicazione: {versione} | Versione libreria: {versioneLibreria}
              {versioniLibrerieExtra && <> | {versioniLibrerieExtra}</>}
            </Box>
          </BaseTesto>
        </Stack>
    </Box>
  )
}